import React__default from 'react';
import '../utils/assertion.esm.js';
import '../utils/ssr.esm.js';
import '../utils/number.esm.js';
import '../utils/array.esm.js';
import '../utils/breakpoint.esm.js';
import '../utils/context.esm.js';
import { isBrowser } from '../utils/dom.esm.js';
import '../utils/tabbable.esm.js';
import '../utils/dom-query.esm.js';
import '../utils/logger.esm.js';
import '../utils/focus.esm.js';
import '../utils/function.esm.js';
import '../utils/keydown.esm.js';
import '../utils/lazy.esm.js';
import '../utils/object.esm.js';
import '../utils/react-helpers.esm.js';
import '../utils/style-props.esm.js';
import '../utils/tailwind.esm.js';
import { useLatestRef } from './use-latest-ref.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * React hook to manage browser event listeners
 *
 * @param event the event name
 * @param handler the event handler function to execute
 * @param doc the dom environment to execute against (defaults to `document`)
 * @param options the event listener options
 */

function useEventListener(event, handler, doc, options) {
  if (doc === void 0) {
    doc = isBrowser ? document : null;
  }

  var savedHandler = useLatestRef(handler);
  React__default.useEffect(function () {
    if (!doc) {
      return undefined;
    }

    var listener = function listener(e) {
      savedHandler.current(e);
    };

    doc.addEventListener(event, listener, options);
    return function () {
      doc.removeEventListener(event, listener, options);
    };
  }, [event, doc, options, savedHandler]);
  return function () {
    var _doc;

    (_doc = doc) == null ? void 0 : _doc.removeEventListener(event, savedHandler.current, options);
  };
}

export { useEventListener };
//# sourceMappingURL=use-event-listener.esm.js.map
